// src/services/bookingService.js
// Service for booking-related operations and availability calculations
import api from './http';

export async function fetchAvailableTimeSlots(vehicleId, date, isPickup = true) {
  try {
    const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const response = await api.get(`/v1/availability/${vehicleId}`, {
      params: {
        date: dateStr,
        pickup: isPickup.toString()
      }
    });
    return response.data.locations || [];
  } catch (error) {
    console.error('Error fetching available time slots:', error);
    // Return fallback data to avoid breaking the UI
    return getFallbackTimeSlots();
  }
}

// Fallback time slots when API is not available
function getFallbackTimeSlots() {
  return [
    {
      location_id: "lisbon-airport",
      name: "Lisbon Airport",
      time_slots: [
        { time: "09:00", available: true, fee: 0 },
        { time: "11:00", available: true, fee: 0 },
        { time: "14:00", available: true, fee: 0 },
        { time: "16:00", available: true, fee: 0 },
        { time: "18:00", available: false, fee: 15 },
        { time: "20:00", available: true, fee: 25 },
      ],
    },
    {
      location_id: "lisbon-downtown",
      name: "Lisbon Downtown",
      time_slots: [
        { time: "08:00", available: true, fee: 0 },
        { time: "10:00", available: true, fee: 0 },
        { time: "12:00", available: true, fee: 0 },
        { time: "15:00", available: true, fee: 0 },
        { time: "17:00", available: true, fee: 0 },
        { time: "19:00", available: true, fee: 10 },
      ],
    },
    {
      location_id: "porto-airport",
      name: "Porto Airport",
      time_slots: [
        { time: "09:30", available: true, fee: 0 },
        { time: "12:30", available: true, fee: 0 },
        { time: "15:30", available: true, fee: 0 },
        { time: "18:30", available: true, fee: 20 },
      ],
    },
    {
      location_id: "porto-downtown",
      name: "Porto Downtown",
      time_slots: [
        { time: "09:00", available: true, fee: 0 },
        { time: "13:00", available: true, fee: 0 },
        { time: "16:00", available: true, fee: 0 },
        { time: "19:00", available: true, fee: 15 },
      ],
    },
    {
      location_id: "faro-airport",
      name: "Faro Airport",
      time_slots: [
        { time: "10:00", available: true, fee: 0 },
        { time: "14:00", available: true, fee: 0 },
        { time: "17:00", available: true, fee: 0 },
      ],
    },
  ];
}